import { AxiosResponse } from 'axios';
import { api } from './api/api';

export interface IStatus {
    ok: boolean,
    status: number,
    final_url: string,
}

export async function verifyDownloadUrl<T>(url: string) {
  const response: AxiosResponse<T> = await api.get(
    `/checkUrl`,
    {
        params: {
            url: url,
        }
    }
  );

  return response.data;
}
